import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { i18n } from "@/plugins/i18n";
//import "./plugins/Auth";
import "@/api/Auth/AuthPlugin";
import Vuelidate from "vuelidate";
import Vuetify from "vuetify";
import axios from "axios";
import AuthPlugin from "@/api/Auth/AuthPlugin";

Vue.use(Vuelidate);

Vue.prototype.$apiRoot = process.env.VUE_APP_API_URL;
const base = axios.create({
  baseURL: Vue.prototype.$apiRoot
});

Vue.prototype.$http = base;

Vue.config.productionTip = false;

Vue.use(AuthPlugin);

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount("#app");
